import type { SpaceBackdropVariant } from '../components/SpaceBackdrop';

/**
 * The one place that maps a route to a `SpaceBackdrop` variant for
 * logged-in, routed screens (issue #182). `AppShell` is the only caller —
 * before this, the choice of race art vs. nothing was an inline
 * `location.pathname.startsWith('/galaxy')` check duplicated across
 * `App.tsx`'s wrapper div and its style prop. Login/register and the
 * universe/race pickers aren't reached through this function at all: they
 * render outside `<Routes>` and pass `'neutral'` directly where they mount
 * `SpaceBackdrop`.
 */
export function getSpaceBackdropVariant(pathname: string): SpaceBackdropVariant {
    return pathname.startsWith('/galaxy') ? 'deep' : 'surface';
}
